module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-4.jpg?d91d7d3d1043a80ff0ee2279efbe5849";